<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>编辑选配</h3>
                </el-col>
            </el-row>
        </div>
        <el-form label-width="150px" :model="optionalForm" ref="optionalForm" :rules="addOptionalRules">
            <div class="block">
                <h2>选配基本信息</h2>
    
                <el-form-item label="选配名称" label-width="150px" prop="name">
                    <el-input v-model="optionalForm.name"></el-input>
                </el-form-item>
                <el-form-item label="结算方式" prop="accessoryType">
                    <el-radio class="radio" v-model="optionalForm.accessoryType" label="2">按天算</el-radio>
                    <el-radio class="radio" v-model="optionalForm.accessoryType" label="1">按次算</el-radio>
                </el-form-item>
                <el-form-item label="价格" label-width="150px" prop="rental">
                    <el-input v-model="optionalForm.rental"></el-input>
                </el-form-item>
                <el-form-item label="选配押金" label-width="150px" prop="deposit">
                    <el-input v-model="optionalForm.deposit"></el-input>
                </el-form-item>
                <el-form-item label="备注信息" label-width="150px" prop="description">
                    <el-input type="textarea" v-model="optionalForm.description"></el-input>
                </el-form-item>
            </div>
    
            <el-form-item label-width="150px">
                <el-button type="primary" @click="onSubmit">更新</el-button>
                <el-button @click="goBack">取消</el-button>
            </el-form-item>
    
    
        </el-form>
    
    </div>
</template>

<script>
    import {
        putProductDetailsId,
        getProductDetailsId
    } from '../../api/version'
    
    export default {
        data() {
            return {
                optionalForm: {
                    name: '',
                    rental: '',
                    accessoryType: '',
                    deposit: '',
                    description: ''
                },
                addOptionalRules: {
                    name: [{
                        required: true,
                        message: '请填写商品名',
                        trigger: 'blur'
                    }],
                    accessoryType: [{
                        required: true,
                        message: '请选择结算方式',
                        trigger: 'blur'
                    }],
                    rental: [{
                        required: true,
                        message: '请填写价格',
                        trigger: 'blur'
                    }],
                    deposit: [{
                        required: true,
                        message: '请填写押金',
                        trigger: 'blur'
                    }],
    
                }
            }
        },
    
        created() {
            console.log(this.$route.params.id)
            getProductDetailsId(this.$route.params.id).then(res => {
                console.log(res.data, 'e')
                this.optionalForm = JSON.parse(JSON.stringify(res.data))
                this.optionalForm.accessoryType = this.optionalForm.accessoryType + ''
                this.optionalForm.rental = this.optionalForm.rental*100 + ''
                this.optionalForm.deposit = this.optionalForm.deposit*100 + ''
            })
        },
    
        methods: {
            goBack() {
                this.$router.push('/optinalList')
            },
            onSubmit() {
                this.$refs['optionalForm'].validate((valid) => {
                    if (valid) {
                        let data = JSON.parse(JSON.stringify(this.optionalForm))
                        console.log(this.optionalForm)
                        data.rental = data.rental * 1
                        data.deposit = data.deposit * 1
                        data.accessoryType = data.accessoryType * 1
                        putProductDetailsId(this.$route.params.id, sessionStorage.userId, data).then(res => {
                            console.log(res)
                            if (res.data) {
                                this.$message({
                                    message: '更新成功',
                                    type: 'success'
                                });
                                this.goBack()
                            }
                        }, err => {
                            this.$message.error('更新失败')
                        })
                    }
                })
            }
        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }
    
    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    
    .page-footer {
        margin-top: 60px;
        text-align: center;
    }
</style>




// WEBPACK FOOTER //
// EditOptional.vue?dcb489d0